import React, { useState } from "react";
import AOS from "aos"; // Import AOS library
import Banner from "../components/Banner";
import Breadcrumb from "../components/Breadcrumb";
import OfferSec from "../sections/offer/OfferSec";
import * as constants from "../constants";
import { fetchAPI } from "../helper/fetchAPI";
import CustomHelmet from "../components/CustomHelmet";
import { t } from "i18next";
import FullScreenLoader from "../components/FullScreenLoader";
import { useTranslation } from "react-i18next";
import { useCountryPrefix } from "../routes/useCountryPrefix";

const Offer = () => {
    const [offer, setOffer] = useState();
    const { i18n } = useTranslation();
    const countryPrefix = useCountryPrefix();

    const isArabic = i18n.language === "ar";
    const language = isArabic ? "ar" : "en";
    const [isLoaded, setIsLoaded] = useState(false);

    let apiUrl = process.env.REACT_APP_API_URL;

    apiUrl = `${apiUrl}${constants.offer}?language=${language}&region_id=${countryPrefix}`;

    const fetchData = async () => {
        const res = await fetchAPI(apiUrl, "Get");
        if (res?.status === 200) {
            setOffer(res?.data)
            setIsLoaded(true)
        } else {
            setIsLoaded(true)
        }
    }

    React.useEffect(() => {
        AOS.init();
        fetchData();
    }, []);

    //const pathName = ["Home", "Offers"];
    const pathLang = isArabic ? "/ar" : "";
    const pathName = [
        { name: t("home"), path: `/${countryPrefix}${pathLang ? `${pathLang}` : ""}` },
        { name: t("offer") }
    ];

    if (!isLoaded) {
        return (
            <FullScreenLoader />
        )
    }

    return (
        <>
            <CustomHelmet
                title={"Exclusive Real Estate Across Egypt"}
                desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
            />
            <Banner
                title={t("offer")}
                desc={t("banner_desc")}
            ></Banner>
            <Breadcrumb pathName={pathName} />
            <OfferSec data={offer} />
        </>
    );
};

export default Offer;
